module.exports = __webpack_public_path__ + "img/bx-12.51d431a7.jpg";